export default {"src":"/_next/static/image/public/images/social_linkedIn_white.a2a72c24f45eda181e07c3e89ffe3e01.svg","height":13,"width":13};